import React, { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"

import { Modal } from "components"
import { getAddresses } from "services"
import CdsamAddresses from "./CdsamAddresses"
import CdsamForm from "./CdsamForm"
import classes from "./index.module.scss"

const CdAddressModal = props => {
  const {
    isGuestOrder,
    guestDeliveryAddress,
    openMapAddressModal,
    setOpenMapAddressModal,
    selectedUserAccount
  } = props

  const locationOptions =
    useSelector(state =>
      state.systemSettings.locationOptions
    )

  const userDeliveryAddress =
    useSelector(state =>
      state.deliveryInfo.deliveryAddress
    )

  const [userAddresses, setUserAddresses] = useState(null)
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [addressForEdit, setAddressForEdit] = useState(null)
  const [modalContent, setModalContent] = useState("addresses")

  const unmount = useRef(false)

  const getUserAddresses = async () => {
    try {
      const response =
        await getAddresses({
          accountId: selectedUserAccount._id
        })

      if (unmount.current) return

      // filter addresses that their area name doesn't exsit
      const filteredAddresses =
        response.filter(userAddress =>
          userAddress.areaName === "Other Area" ||
          locationOptions.some(lo =>
            lo.areaName === userAddress.areaName
          )
        )

      setUserAddresses([...filteredAddresses])
    } catch (err) {
      console.log(err)
    }
  }

  const handleExited = () => {
    setModalContent("addresses")

    setAddressForEdit(null)

    setSelectedAddress(null)
  }

  const handleEnter = () => {
    if (isGuestOrder) {
      setAddressForEdit({ ...guestDeliveryAddress })

      return setModalContent("form")
    }

    getUserAddresses()

    !!userDeliveryAddress &&
      setSelectedAddress(userDeliveryAddress)
  }

  useEffect(() => {
    setUserAddresses(null)
  }, [selectedUserAccount])

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  return (
    <Modal

      backdrop="static"
      onEscapeKeyDown={() => { }}
      onEnter={handleEnter}
      onExited={handleExited}
      show={openMapAddressModal}
      onHide={() => setOpenMapAddressModal(false)}
    >
      <div className={classes["container"]}>
        {
          modalContent === "addresses" &&
          <CdsamAddresses
            setModalContent={setModalContent}
            userAddresses={userAddresses}
            setUserAddresses={setUserAddresses}
            selectedAddress={selectedAddress}
            setSelectedAddress={setSelectedAddress}
            setAddressForEdit={setAddressForEdit}
            setOpenMapAddressModal={setOpenMapAddressModal}
            selectedUserAccount={selectedUserAccount}
          />
        }
        {
          modalContent === "form" &&
          <CdsamForm
            isGuestOrder={isGuestOrder}
            addressForEdit={addressForEdit}
            setAddressForEdit={setAddressForEdit}
            setUserAddresses={setUserAddresses}
            setSelectedAddress={setSelectedAddress}
            setModalContent={setModalContent}
            selectedUserAccount={selectedUserAccount}
            setOpenMapAddressModal={setOpenMapAddressModal}
          />
        }
      </div>
    </Modal>
  )
}

export default CdAddressModal